<mat-nav-list class="vault-nav-list" [disableRipple]="false">
    <mat-list-item [ngClass]="{ active: isActive }" (click)="selectRootFolder()">
        <mat-icon mat-list-icon>{{ vault?.sub_directories?.length > 0 ? 'folder_open' : 'folder' }}</mat-icon>
        <p mat-line>{{ 'VAULT.ROOT_TEXT' | translate }}</p>
    </mat-list-item>
    <mat-divider *ngIf="vault?.sub_directories?.length > 0"></mat-divider>
    <app-vault-nav-item *ngFor="let directory of vault?.sub_directories; trackBy: trackByIndex" [directory]="directory"></app-vault-nav-item>
</mat-nav-list>
